module.exports = __webpack_public_path__ + "img/forum_on.df78abfc.svg";